import { FC, SVGProps } from 'react';

export const PlayIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M25.0924 14.2251C26.4587 15.0139 26.4587 16.9861 25.0924 17.7749L10.9909 25.9164C9.62457 26.7053 7.91664 25.7192 7.91664 24.1415L7.91664 7.85851C7.91664 6.28079 9.62457 5.29472 10.9909 6.08358L25.0924 14.2251ZM24.3424 16.4759C24.7087 16.2644 24.7087 15.7356 24.3424 15.5241L10.2409 7.38262C9.87457 7.17111 9.41664 7.43549 9.41664 7.85851L9.41664 24.1415C9.41664 24.5645 9.87457 24.8289 10.2409 24.6174L24.3424 16.4759Z"
			fill="currentColor"
		/>
	</svg>
);
